import FD from '../../../RestAPI/fetchData';
import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const saveQuestionAttemptStats = async (data) => {
  const { questionId = '', rightAnswer = '', timeDone = '', selectedChoice = '' } = data;
  return await FD.callAPI(`${config.backend_api}/exams/cfa/question-bank/save-stats`, {
    questionId,
    rightAnswer,
    timeDone,
    selectedChoice,
  });
};

const fetchSavedQuestion = async (data) => {
  const { question_id = '' } = data;
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/question-bank/save-question`, {
    questionId: question_id,
  });
};
const saveQuestion = async (data) => {
  const { question_id } = data;
  return await FD.callAPI(`${config.backend_api}/exams/cfa/question-bank/save-question`, {
    questionId: question_id,
  });
};
const deleteSavedQuestion = async (data) => {
  const { question_id = '' } = data;
  return await FD.callAPI(`${config.backend_api}/exams/cfa/question-bank/un-save-question`, {
    questionId: question_id,
  });
};

const fetchQuestionsReadingWise = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/question-bank/all-questions`, data);
};
const reportQuestion = async (data) => {
  const { question_id = '', comment = '' } = data;
  return await FD.callAPI(`${config.backend_api}/exams/cfa/question-bank/report-question`, {
    questionId: question_id,
    comment,
  });
};
module.exports = {
  saveQuestionAttemptStats,
  fetchQuestionsReadingWise,
  fetchSavedQuestion,
  saveQuestion,
  deleteSavedQuestion,
  reportQuestion,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionView/ApiService.js